

import { useNavigate } from 'react-router-dom';

export const Terms = () => {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-obsidian-900 text-white p-6 md:p-12">
            <div className="max-w-4xl mx-auto">
                <button onClick={() => navigate('/')} className="mb-8 text-volt-400 hover:text-volt-300">← Back to Home</button>
                <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
                <div className="space-y-6 text-gray-300">
                    <p>Last updated: December 12, 2025</p>
                    <p>Please read these Terms of Service ("Terms") carefully before using the Forecaster platform.</p>
                    <h2 className="text-2xl font-bold text-white mt-8">1. Acceptance of Terms</h2>
                    <p>By accessing or using our service, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not use the service.</p>
                    <h2 className="text-2xl font-bold text-white mt-8">2. Use License</h2>
                    <p>Permission is granted to temporarily download one copy of the materials (information or software) on Forecaster's website for personal, non-commercial transitory viewing only.</p>
                    <h2 className="text-2xl font-bold text-white mt-8">3. Disclaimer</h2>
                    <p>The materials on Forecaster's website are provided on an 'as is' basis. Forecaster makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties.</p>
                </div>
            </div>
        </div>
    );
};
